import React from "react";

import { Link } from "react-router-dom";
import logo from "../../Assets/images/yt_logo_rgb_light.png";
import classes from "./Header.module.css";

export default function LogoAndIco(props) {
  return (
    <div className={classes.LogoAndIco}>
      <div className={classes.Hamburger} onClick={props.toggleSideBar}>
        <div />
        <div />
        <div />
      </div>
      <div className={classes.Logo}>
        <Link to="/">
          <img src={logo} alt="YouTube" />
        </Link>
        <span>{props.country}</span>
      </div>
    </div>
  );
}
